(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function whenSlickReady(cb, tries) {
    tries = tries || 0;
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      cb(window.jQuery);
    } else if (tries < 40) {
      setTimeout(function () { whenSlickReady(cb, tries + 1); }, 75);
    } else {
      console.warn('Slick Slider failed to load for video testimonials section.');
    }
  }

  ready(function () {
    whenSlickReady(function ($) {
      document.querySelectorAll('.vt-section').forEach(function (section) {
        initTestimonialSection(section, $);
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (e) {
          var section = e.target.querySelector('.vt-section');
          if (section) initTestimonialSection(section, $);
        });
      }
    });
  });

  function initTestimonialSection(section, $) {
    if (!section || section.dataset.vtInit) return;
    section.dataset.vtInit = 'true';

    var $track = $(section).find('[data-vt-track]');
    var prevBtn = section.querySelector('[data-vt-prev]');
    var nextBtn = section.querySelector('[data-vt-next]');
    var dotsWrap = section.querySelector('[data-vt-dots]');
    var currentEl = section.querySelector('[data-vt-current]');
    var totalEl = section.querySelector('[data-vt-total]');
    var progressFill = section.querySelector('[data-vt-progress]');
    var slideCount = $track.children('[data-vt-slide]').length;

    if (!$track.length || !slideCount) return;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    if (totalEl) totalEl.textContent = pad(slideCount);

    $track.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: slideCount > 5,
      arrows: false,
      dots: true,
      appendDots: $(dotsWrap),
      touchThreshold: 100,
      speed: 400,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            infinite: slideCount > 3
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            //centerMode: true,
            //centerPadding: '14%',
            infinite: slideCount > 2
          }
        }
      ]
    });

    function updateCounter(currentIndex) {
      var idx = currentIndex % slideCount;
      if (currentEl) currentEl.textContent = pad(idx + 1);
      if (progressFill) progressFill.style.width = ((idx + 1) / slideCount) * 100 + '%';
    }

    updateCounter(0);

    $track.on('afterChange', function (event, slick, currentSlide) {
      updateCounter(currentSlide);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        $track.slick('slickPrev');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        $track.slick('slickNext');
      });
    }

    // ---- Read more / read less ----
    var readMoreBtn = section.querySelector('[data-vt-readmore]');
    var readLessBtn = section.querySelector('[data-vt-readless]');
    var fullText = section.querySelector('[data-vt-fulltext]');
    var shortTextP = section.querySelector('.vt-short-text');

    if (readMoreBtn && fullText) {
      readMoreBtn.addEventListener('click', function () {
        fullText.hidden = false;
        shortTextP.hidden = true;
        $track.slick('setPosition');
      });
    }
    if (readLessBtn && fullText) {
      readLessBtn.addEventListener('click', function () {
        fullText.hidden = true;
        shortTextP.hidden = false;
        $track.slick('setPosition');
      });
    }

    // ---- Inline video playback (plays inside the same card, not a popup) ----
    var activeCard = null;

    // Clicking anywhere on the card (thumbnail, overlay, play icon, etc.)
    // starts playback. Once a card is playing, clicks are left alone so the
    // native video/iframe controls and the close button keep working.
    section.querySelectorAll('[data-vt-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.classList.contains('is-playing')) return;
        playInline(card);
      });
    });

    function stopInline(card) {
      var media = card.querySelector('[data-vt-media]');
      var player = media ? media.querySelector('.vt-inline-player') : null;
      var closeBtn = media ? media.querySelector('.vt-close-btn') : null;
      if (player) player.remove();
      if (closeBtn) 
        closeBtn.remove();
      card.classList.remove('is-playing');
      if (activeCard === card) activeCard = null;
    }

    function playInline(card) {
      // stop any other card currently playing
      if (activeCard && activeCard !== card) stopInline(activeCard);

      var media = card.querySelector('[data-vt-media]');
      if (!media || media.querySelector('.vt-inline-player')) return;

      var type = card.dataset.videoType;
      var url = card.dataset.videoUrl;
      var file = card.dataset.videoFile;

      var player = document.createElement('div');
      player.className = 'vt-inline-player';

      if (type === 'file' && file) {
        var video = document.createElement('video');
        video.src = file;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        player.appendChild(video);
      } else if (type === 'youtube' && url) {
        var ytId = extractYouTubeId(url);
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0&playsinline=1';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        player.appendChild(iframe);
      } else if (type === 'vimeo' && url) {
        var vimeoId = extractVimeoId(url);
        var vIframe = document.createElement('iframe');
        vIframe.src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1';
        vIframe.allow = 'autoplay; fullscreen; picture-in-picture';
        vIframe.allowFullscreen = true;
        player.appendChild(vIframe);
      } else if (type === 'url' && url) {
        var vid = document.createElement('video');
        vid.src = url;
        vid.controls = true;
        vid.autoplay = true;
        vid.playsInline = true;
        player.appendChild(vid);
      } else {
        var msg = document.createElement('p');
        msg.style.cssText = 'color:#fff;padding:16px;text-align:center;font-size:12px;';
        msg.textContent = 'No video source configured.';
        player.appendChild(msg);
      }

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'vt-close-btn';
      closeBtn.setAttribute('aria-label', 'Close video');
      closeBtn.innerHTML = '&times;';
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stopInline(card);
      });

      media.appendChild(player);
      media.appendChild(closeBtn);
      card.classList.add('is-playing');
      activeCard = card;
    }

    // stop playback when the slide changes so audio doesn't keep running off-screen
    $track.on('beforeChange', function () {
      if (activeCard) stopInline(activeCard);
    });

    function extractYouTubeId(url) {
      var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/);
      return m ? m[1] : '';
    }
    function extractVimeoId(url) {
      var m = url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
      return m ? m[1] : '';
    }
  }
})();